module.exports = __webpack_public_path__ + "img/capa.c56c1853.jpg";